import { SxProps } from "@mui/material";

export const sxTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "24px",
  fontWeight: 700,
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left",
};

export const sxTabs: SxProps = {
  width: "100%",
  "& .MuiTabs-indicator": {
    height: "4px",
    borderBottom: '4px solid #00995D'
  },
};

export const sxTabsAccessibility: SxProps = {
  ...sxTabs,
  '& .MuiTabs-indicator': {
    height: '4px',
    background: '#FFFF00'
  },
};

export const sxTab: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "16px",
  fontWeight: 700,
  letterSpacing: "0em",
  textAlign: "center",
  textTransform: "none",
  color: "#383838",
  flex: "1 1",
  padding: "12px 12px",
  maxWidth: "unset !important",
  borderBottom: "4px solid #BDBDBD",
  "@media (max-width: 350px)": {
    padding: "12px 4px",
  },
};

export const sxDarkGreyBody: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0em",
  textTransform: "none",
  color: "#4C4C4C",
};

export const sxFormTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0em",
  textTransform: "none",
  color: "#383838",
};

export const sxTooltipRadioFormLabel: SxProps = {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const sxTooltipCheckFormLabel: SxProps = {
  width: "100%",
  display: "flex",
  gap: "15px",
  alignItems: "center",
};

export const sxFormControlLabel: SxProps = {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  "& .MuiFormControlLabel-label": {
    width: "100%",
  },
  color: "#4C4C4C",
};

export const sxBoxNotificationsPermissionsForm: SxProps = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  "@media (max-width: 685px)": {
    gap: "15px",
  },
};

export const sxButton: SxProps = {
  borderRadius: "80px",
  height: "44px",
  padding: "24px 32px",
  maxWidth: "fit-content",
  "@media (max-width: 768px)": {
    maxWidth: "unset",
  },
};

export const sxTrustedDoctorsCardContainer: SxProps = {
  display: "flex",
  padding: "8px 16px",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  borderRadius: "8px",
  background: "var(--grey-light-white, #FFF)",
};

export const sxAddTrustedDoctorsCardContainer: SxProps = {
  display: "flex",
  padding: "8px 16px",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  borderRadius: "8px",
  background: "var(--grey-light-white, #FFF)",
  maxWidth: "630px",
};

export const sxCircularLoadingProgress: SxProps = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "750px",
  height: "100%",
  alignItems: "center",
  marginTop: "100px",
};

export const sxLabel: SxProps = {
  fontFamily: "Unimed-Sans",
  color: "#383838",
  fontWeight: 600,
};

export const sxInput: SxProps = {
  fontFamily: "Unimed-Sans",
  color: "#383838",
  fontWeight: 400,
  fontSize: "14px",
  "@media (min-width: 768px) and (max-width: 899px)": {
    minWidth: "400px",
  },
};
export const sxLabeledOutlinedInput: SxProps = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  width: "inherit",
  "@media (max-width: 768px)": {
    width: "100%",
    maxWidth: "unset",
  },
  maxWidth: "466px",
};
export const sxFindDoctorBox: SxProps = {
  display: "flex",
  flexWrap: "wrap",
  gap: "15px",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "100%",
};

export const sxBoxActions: SxProps = {
  display: "flex",
  alignItems: "center",
  gap: "24px",
};
